import CompanyPage from "../containers/Company/CompanyPage"
import LocationPage from "../containers/Location/LocationPage"
import UserPage from "../containers/User/UserPage"

let RegisterSubRoutes = [
    {
        path: '/users/*',
        container: UserPage,
        exact: true,
    },
    {
        path: '/companies/*',
        container: CompanyPage,
        exact: true,
    },
    {
        path: '/locations/*',
        container: LocationPage,
        exact: true,
    }
]
export default RegisterSubRoutes